<script lang="ts">
	import { onMount, onDestroy } from "svelte";

	import { fly } from "svelte/transition";
	import Logo from "./Logo.svelte";
	import { goto, yyyy, zzzz } from "./store.svelte";
	import { toast } from "./lib/toast.svelte.ts";

	let ready: boolean = false;

	let goSignIn = () => {
		goto("/sign-in");
	};

	// let goSignUp = () => {
	// 	zzzz.emit("goto", "/waitlist");
	// };

	let goLearnMore = () => {
		goto("/learn-more");
	};

	let goPricing = () => {
	goto("/pricing");
	};

	let goDemo = () => {
		goto("/schedule-a-demo")
	};

	onMount(() => {
		console.log(`Appcard | params are: ${yyyy.params}`);

		if (yyyy.params && yyyy.params.has("b") && !yyyy.sesh.logtoken) {
			toast.warning(`You need to be signed in to access bookmarks`);

			zzzz.emit("goto", "/signin");
		}

		setTimeout(() => {
			ready = true;
			yyyy.logo.usage = "logo";
		}, yyyy.logo.time);
	});

	onDestroy(() => {
		yyyy.logo.time = 877.5;
		yyyy.logo.usage = "wait";
	});
</script>

<!-- <svelte:window on:pushstate={routing} /> -->
<div class="column is-one-quarter porridge">
	<div class="card lvwr-card" class:zeroBG={!ready}>
		<div
			class="card-content lvwr-card-content"
			transition:fly|local={{ y: -200 }}
		>
			<h1 class="title thin lvwr-title" class:dim={!ready} class:bri={ready}>Livewire</h1>
			<h2 class="subtitle thin lvwr-subtitle" class:dim={!ready} class:bri={ready}>
				Power Delivery Modelling in the Cloud by
			</h2>
			<div class="content">
				<Logo usage={yyyy.logo.usage} interact={true} />
			</div>
			<div class="content lvwr-content" class:dim={!ready} class:bri={ready}>
				<button
					onclick={goLearnMore}
					class="button is-fullwidth lvwr-toggle-orange">Learn more</button
				>
				<hr />
				<button
					onclick={() => goto("/use-cases")}
					class="button is-fullwidth lvwr-toggle-orange">Use Cases</button
				>
				<hr />
				<button
					onclick={goPricing}
					class="button is-fullwidth lvwr-toggle-orange">Pricing</button
				>
			</div>
		</div>
		<footer
			class="card-footer"
			class:dim={!ready}
			class:bri={ready}
			transition:fly|local={{ y: 200 }}
		>
			<div class="card-footer-item sign-in-up-footer">
				<button onclick={goSignIn} class="button lvwr-toggle">Sign-In</button>
				<button onclick={goDemo} class="button lvwr-toggle">Schedule a Demo</button
				>
			</div>
		</footer>
	</div>
</div>

<style>
	.porridge {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		height: fit-content;
		z-index: 5;
	}

	.lvwr-card-content {
		height: 410px;
	}

	.card-content {
		height: 410px;
	}

	hr {
		background-color: #eee;
		height: 1px;
		margin: 1rem 0;
	}
</style>
